import { Link, useParams } from "react-router-dom";
import { ModelViewer } from "../components/ModelViewer";
import { ProductHero } from "../components/ProductHero";
import { CatalogCta, CatalogLayout, ProductGrid } from "../components/catalog";
import { getProduct } from "../data/products";
import { NotFoundPage } from "./NotFoundPage";
export function ProductDetailPage() {
  const { slug } = useParams();
  const t = getProduct(slug);
  if (t) {
    return (
      <CatalogLayout title={t.name} description={t.intro}>
        <ProductHero product={t} />
        <nav className="catalog-wrap catalog-tabs" aria-label="Related products">
          {t.slug.startsWith("thor-") && <Link to="/products/thor-ego">Series overview</Link>}
          {[t, ...t.related.map(getProduct).filter((n) => !!n)].map((n) => (
            <Link aria-current={n.slug === slug ? "page" : undefined} to={`/products/${n.slug}`} key={n.slug}>
              {n.name}
            </Link>
          ))}
        </nav>
        {["atlas-m", "atlas-r1", "fmg-imu"].includes(t.slug) && (
          <ModelViewer model={t.slug} image={t.image} key={t.slug} />
        )}
        <section className="catalog-band industrial-features">
          <div className="catalog-wrap catalog-section">
            <p className="catalog-kicker">Design & capability</p>
            <h2>Designed for the task.</h2>
            <div className="catalog-features">
              {t.features.map(([n, r]) => (
                <article key={n}>
                  <h3>{n}</h3>
                  <p>{r}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
        <section className="catalog-wrap catalog-section">
          <div className="catalog-section-head">
            <h2>Specifications</h2>
            <p>Configuration details and measurement conditions.</p>
          </div>
          {t.groups.map((n) => (
            <section className="catalog-spec-group" key={n.title}>
              <div className="catalog-table-scroll" tabIndex={0} aria-label={n.title}>
                <table>
                  <caption>{n.title}</caption>
                  {n.columns && (
                    <thead>
                      <tr>
                        {n.columns.map((r) => (
                          <th scope="col" key={r}>
                            {r}
                          </th>
                        ))}
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {n.rows.map((r) => (
                      <tr key={r[0]}>
                        <th scope="row">{r[0]}</th>
                        {r.slice(1).map((i, o) => (
                          <td key={o}>{i}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {n.note && <p className="catalog-note">{n.note}</p>}
            </section>
          ))}
        </section>
        <section className="catalog-band">
          <div className="catalog-wrap catalog-section catalog-two">
            <div>
              <p className="catalog-kicker">Delivery and validation</p>
              <h2>Agree on the complete configuration.</h2>
              <p className="catalog-note">{t.note}</p>
            </div>
            <ul className="catalog-checklist">
              {t.delivery.map((n) => (
                <li key={n}>{n}</li>
              ))}
            </ul>
          </div>
        </section>
        {t.category === "Robotics" && (
          <section className="catalog-wrap catalog-section catalog-first">
            <p className="catalog-kicker">Training and deployment</p>
            <h2>Plan compute for this platform.</h2>
            <p>Plan GPU compute, model training and hosted inference, with control kept on the robot.</p>
            <Link className="catalog-text-link" to="/training">
              Training & Compute →
            </Link>
          </section>
        )}
        <section className="catalog-wrap catalog-section">
          <h2>Related products</h2>
          <ProductGrid products={t.related.map(getProduct).filter((n) => !!n)} />
        </section>
        <CatalogCta />
      </CatalogLayout>
    );
  } else {
    return <NotFoundPage />;
  }
}
